export default "__VITE_ASSET__BuVyoRPi__"